import { useState } from 'react'
import { useSelector } from 'react-redux';
import iconenquiry from "../../../Images/icon-enquiry.png";
import BlmEnquiryModal from '../../../Modal/BlmEnquiryModal';

const BusinessListingEnquiry = (isActive) => {
    const { UserProfileID } = useSelector((state) => state.app);
    const [ownpostupdatemodal, setownpostupdatemodal] = useState(false);

    const ownnsposyymodal = () => {
        setownpostupdatemodal(!ownpostupdatemodal)
    }

    return (
        <>
            <div className='bmlmmaposttaddddib'>
                <div className='bmlmmaposttaddddibdivmain'>
                    <div className='poisyybtnmainlibkldivflx'>
                        {/* <button
                            className='poisyybtnmain'
                            onClick={ownnsposyymodal}
                            disabled={!UserProfileID?.businessStatus}
                        >
                            Send Enquiry
                            <i className="fa-solid fa-plus"></i>
                        </button> */}
                        <button className="direxrrcttstbtn"
                            style={{
                                margin: "0 auto"
                            }}
                            onClick={ownnsposyymodal}
                        >
                            <img src={iconenquiry} alt="arrow icon"
                                style={{
                                    marginRight: "5px"
                                }}
                            />
                            Send Enquiry
                        </button>

                    </div>
                </div>
            </div>
            {ownpostupdatemodal && <BlmEnquiryModal closemodal={setownpostupdatemodal} />}
        </>
    )
}

export default BusinessListingEnquiry
